import { render, staticRenderFns } from "./DB_EditorTools.vue?vue&type=template&id=70fc5a92&scoped=true&"
import script from "./DB_EditorTools.vue?vue&type=script&lang=ts&"
export * from "./DB_EditorTools.vue?vue&type=script&lang=ts&"
import style0 from "./DB_EditorTools.vue?vue&type=style&index=0&id=70fc5a92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fc5a92",
  null
  
)

export default component.exports